import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/7_elegant-8/7_elegant-8"
 * Contains 4 texture(s)
 */
export class CardsFront7Elegant8Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/7_elegant-8/7_elegant-8';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '10-spades.png',
        '10-hearts.png',
        '10-diamonds.png',
        '10-clubs.png'
    ] as const;
}
